/* eslint-disable max-lines-per-function */
import React from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
// import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import ListItemText from "@material-ui/core/ListItemText";
import { uniqBy } from "lodash";
import TableContext from "../context";
import { toKabobCase } from "../utils";
import { useInterestsTable } from "../interests-table/table-context";
import styles from "./button-mark-selected.module.css";

type DropDownProps = {
  onStatusChange: (status: string, reason: string | null) => Promise<any>;
  closeMenu?: () => void;
  className?: string;
  loading: boolean;
}
const StatusOptions: React.FC<DropDownProps> = ({
  onStatusChange,
  closeMenu,
  className,
  loading,
}) => {
  const { totalSelectedInterests } = useInterestsTable();
  return (
    <TableContext.Consumer>
      {(query) => {
        if (!query?.data || query?.loading || query?.error) {
          return null;
        }

        const stages = uniqBy(query.data.interestListsById.map((x) => x.property.stages).flat().filter((stage) => stage.enabled), "name");

        return stages
          .map(({ name: status }) => (
            <MenuItem
              id={`actions-mark-selected-${toKabobCase(status)}`}
              key={status}
              className={className ?? ""}
              disabled={loading}
              onClick={() => {
                onStatusChange(status, null)
                  .finally(() => {
                    if (closeMenu) closeMenu();
                  });
              }}
            >
              {status} {`(${totalSelectedInterests})`}
            </MenuItem>
          ));
      }}
    </TableContext.Consumer>);
};

interface Props {
  isAvailable: boolean;
  actionsButton?: boolean;
  closeMenu?: () => void;
  onStatusChange: (status: string, reason: string | null) => Promise<any>;
  loading: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper,
    },
    nested: {
      paddingLeft: theme.spacing(4),
    },
  }));

const ButtonMarkSelected: React.FC<Props> =
({ actionsButton, isAvailable, onStatusChange, closeMenu, loading }) => {

  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const toggleMenu = () => setOpen(!open);

  if (actionsButton) {
    return (
      <>
        <ListItem button onClick={toggleMenu} style={{ flexDirection: "row" }}>
          <ListItemText primary="Change Status" />
          {open ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <StatusOptions
              onStatusChange={onStatusChange}
              closeMenu={closeMenu}
              className={classes.nested}
              loading={loading}
            />
          </List>
        </Collapse>
      </>
    );
  }
  return (
    <PopupState variant="popover" popupId="actions-mark-selected-menu">
      {(popupState) => (
        <>
          <div className={styles.container}>
            <div 
              className={styles.buttonContent}
              {...bindTrigger(popupState)}
              id="actions-mark-selected"
              style={{ opacity: !isAvailable || loading ? 0.5 : 1 }}
            >
              <span style={{ 
                fontWeight: 800,
                color: '#B8B8B8',
                textAlign: 'center',
                flex: 1
              }}>
                Change Status
              </span>
              <ExpandMore fontSize="small" />
            </div>
          </div>
          <Menu {...bindMenu(popupState)}>
            <StatusOptions onStatusChange={onStatusChange} loading={loading} />
          </Menu>
        </>
      )}
    </PopupState>
  );
};

export default ButtonMarkSelected;
